'use strict';
var $ = require('../internals/export');

var getFullYear = Date.prototype.getFullYear;

// `Date.prototype.getYear` method
// https://tc39.es/ecma262/#sec-date.prototype.getyear
$({ target: 'Date', proto: true }, {
  getYear: function getYear() {
    return getFullYear.call(this) - 1900;
  }
});



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/web/app/themes/sanacorp/node_modules/core-js/modules/es.date.get-year.js
// module id = 372
// module chunks = 0